import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, exhaustMap, map } from 'rxjs/operators';
import { ScenariosActions } from './scenarios.actions';
import { ScenariosService } from './scenarios.service';

@Injectable()
export class ScenariosEffects {
  private readonly actions$ = inject(Actions);
  private readonly scenariosService = inject(ScenariosService);

  loadHomeScenarios$ = createEffect(() => this.actions$.pipe(
    ofType(ScenariosActions.getScenarios),
    exhaustMap((action) => this.scenariosService.loadScenarios(action.homeId)
      .pipe(
        map(payload => ScenariosActions.getScenariosSuccess(payload)),
        catchError((error) => of(ScenariosActions.getScenariosFailure(error))),
      ),
    )),
  );

  setScenarios$ = createEffect(() => this.actions$.pipe(
    ofType(ScenariosActions.setScenarios),
    exhaustMap((action) => this.scenariosService.setScenarios(action.params)
      .pipe(
        map(() => ScenariosActions.setScenariosSuccess({ home: action.params.home })),
        catchError((error) => of(ScenariosActions.setScenariosFailure(error))),
      ),
    )),
  );
}
